angular.module('admin.directives')

.directive('avmCmaDisplay', ['Dictionary', function(Dictionary){
  return {
    controllerAs: 'cmaCtrl',
    bindToController: {
      agent: '=',
      cmaAction: '&',
      home: '=',
      requester: '=',
    },
    scope: {},
    restrict: 'AE',
    templateUrl: function(el, attrs){
      return '/admin/templates/partials/cma/'+attrs.template+'.html';
    },

    controller: function(){
      var ctrl = this;
      var dictionary = new Dictionary();

      ctrl.homeValue = _.get(ctrl.home, 'metadata.homeValue');
      ctrl.hasTuneFeature = true;
      ctrl.lookup = function(prop,args){
        return dictionary[prop](ctrl.home,args);
      };
    }
  }

}]);
